/* assets/bundle-cart-errors.js
 * Surfaces Shopify Cart AJAX (422) validation errors — e.g. the minimum-order-quantity
 * rejections returned when the Recharge build-a-box widget posts to /cart/add.js — as a
 * toast that slides in from the lower-right.
 *
 * Styled with the theme's own design tokens (theme.css): --dialog-background,
 * --text-primary, --error-text, --spacing-*, --rounded-sm, --shadow-md, and the
 * Barlow Condensed uppercase treatment used for component titles.
 *
 * Loaded only on the bundle template (see the {% if template.suffix == 'bundle' %}
 * guard in theme.liquid). Self-contained: no dependencies, injects its own styles once.
 */
window.RC_BUNDLE_EDIT_CONFIG = window.RC_BUNDLE_EDIT_CONFIG || {
  useNativeRechargeQueryPrefill: false,
  debug: false,

  // Faster edit-mode prefill tuning.
  prefillAddStaggerMs: 10,
  prefillQuantityRenderWaitMs: 10,
  prefillQuantityStepDelayMs: 10
};;

(function () {
  'use strict';

  var TOAST_TTL = 6000;                 // ms on screen before auto-dismiss
  var STYLE_ID = 'bce-toast-styles';
  var CONTAINER_ID = 'bce-toast-container';


  document.addEventListener('click', function () {
    document.querySelectorAll('.recharge-tooltip').forEach(function (t) {
      t.style.display = 'none';
    });
  });

  // --- Styles (injected once) ----------------------------------------------
  function ensureStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '#' + CONTAINER_ID + '{',
      '  position:fixed; z-index:2147483000;',
      '  right:var(--spacing-2); bottom:var(--spacing-2); left:var(--spacing-2);',
      '  display:flex; flex-direction:column; gap:var(--spacing-2);',
      '  pointer-events:none;',
      '}',
      '.bce-toast{',
      '  --text-color:var(--text-primary);',
      '  pointer-events:auto;',
      '  display:grid; grid-template-columns:max-content auto max-content;',
      '  align-items:start; gap:var(--spacing-3-5);',
      '  padding:var(--spacing-4);',
      '  background:rgb(var(--dialog-background));',
      '  color:rgb(var(--text-primary));',
      '  border:1px solid rgb(var(--text-color) / .12);',
      '  border-inline-start:4px solid rgb(var(--error-text));',
      '  border-radius:var(--rounded-sm);',
      '  box-shadow:var(--shadow-md);',
      '  font-family:var(--text-font-family);',
      '  transform:translateX(120%); opacity:0;',
      '  transition:transform .25s ease-in-out, opacity .25s ease-in-out;',
      '}',
      '.bce-toast.is-visible{ transform:translateX(0); opacity:1; }',
      '.bce-toast__icon{ color:rgb(var(--error-text)); margin-block-start:2px; }',
      '.bce-toast__icon svg{ display:block; width:20px; height:20px; }',
      '.bce-toast__body{ min-width:0; }',
      '.bce-toast__title{',
      '  margin:0 0 var(--spacing-1);',
      '  font-family:"Barlow Condensed", sans-serif;',
      '  font-weight:600; text-transform:uppercase; letter-spacing:0.05em;',
      '  font-size:16px; line-height:20px;',
      '}',
      '.bce-toast__message{',
      '  margin:0; font-size:var(--text-sm); line-height:1.6;',
      '  color:rgb(var(--text-color)); overflow-wrap:anywhere;',
      '}',
      '.bce-toast__close{',
      '  align-self:start; appearance:none; border:0; background:none; cursor:pointer;',
      '  margin:-2px -2px 0 0; padding:0 2px; line-height:1; font-size:20px;',
      '  color:rgb(var(--text-color) / .5); transition:color .2s ease-in-out;',
      '}',
      '.bce-toast__close:hover{ color:rgb(var(--text-color)); }',
      '@media screen and (min-width:700px){',
      '  #' + CONTAINER_ID + '{',
      '    right:var(--spacing-4); bottom:var(--spacing-4); left:auto;',
      '    width:100%; max-width:445px;',
      '  }',
      '  .bce-toast__title{ font-size:18px; }',
      '}',
      '@media (prefers-reduced-motion: reduce){',
      '  .bce-toast{ transform:none; transition:opacity .2s ease-in-out; }',
      '}'
    ].join('');
    document.head.appendChild(style);
  }

  function getContainer() {
    var c = document.getElementById(CONTAINER_ID);
    if (!c) {
      c = document.createElement('div');
      c.id = CONTAINER_ID;
      document.body.appendChild(c);
    }
    return c;
  }

  // --- Public-ish: show one error toast ------------------------------------
  function showCartError(message) {
    ensureStyles();

    var toast = document.createElement('div');
    toast.className = 'bce-toast';
    toast.setAttribute('role', 'alert');
    toast.setAttribute('aria-live', 'assertive');
    toast.innerHTML =
      '<span class="bce-toast__icon" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
      'stroke-linecap="round" stroke-linejoin="round">' +
      '<circle cx="12" cy="12" r="10"></circle>' +
      '<line x1="12" y1="8" x2="12" y2="12"></line>' +
      '<line x1="12" y1="16" x2="12.01" y2="16"></line>' +
      '</svg>' +
      '</span>' +
      '<div class="bce-toast__body">' +
      '<p class="bce-toast__title">Couldn\u2019t add to cart</p>' +
      '<p class="bce-toast__message"></p>' +
      '</div>' +
      '<button class="bce-toast__close" type="button" aria-label="Dismiss">&times;</button>';

    // textContent (never innerHTML) so a server-supplied string can't inject markup.
    toast.querySelector('.bce-toast__message').textContent =
      message || 'Some items are below the minimum order quantity.';

    getContainer().appendChild(toast);
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });

    var timer;
    function dismiss() {
      clearTimeout(timer);
      toast.classList.remove('is-visible');
      toast.addEventListener('transitionend', function () { toast.remove(); }, { once: true });
      // Safety net if transitionend never fires (e.g. reduced-motion path).
      setTimeout(function () { if (toast.isConnected) toast.remove(); }, 500);
    }
    function arm() { timer = setTimeout(dismiss, TOAST_TTL); }

    toast.querySelector('.bce-toast__close').addEventListener('click', dismiss);
    toast.addEventListener('mouseenter', function () { clearTimeout(timer); }); // pause on hover
    toast.addEventListener('mouseleave', arm);
    arm();

    return dismiss; // hand back a handle in case you ever want to close it programmatically
  }

  // --- Cart AJAX 422 interceptor -------------------------------------------
  // window.fetch is already wrapped by other scripts (global.js, shop_events_listener);
  // wrapping again is safe because fetch wrappers chain — the response still reaches us.
  var origFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    return origFetch.apply(this, args).then(function (res) {
      try {
        var first = args[0];
        var url = (first && first.url) || first || '';
        if (typeof url === 'string' &&
          /\/cart\/(add|update|change)(\.js)?/.test(url) &&
          res.status === 422) {
          // clone() so Recharge's own code can still read the original body.
          res.clone().json()
            .then(function (data) { showCartError(data && data.message); })
            .catch(function () { showCartError(); });
        }
      } catch (e) { /* never let the interceptor break the cart */ }
      return res;
    });
  };
})();

// ---------------------------------------------------------------------------
// Bundle edit mode
// Triggered when the customer clicks "Edit" on a bundle cart item.
// Renames the Recharge widget's "Add to cart" button to "Update cart" and
// removes the old bundle from the cart once the updated bundle is added.
// ---------------------------------------------------------------------------
(function () {
  'use strict';

  var params = new URLSearchParams(window.location.search);
  if (!params.has('rc_edit')) return;

  var pathParts = window.location.pathname.replace(/\/$/, '').split('/');
  var handle = pathParts[pathParts.length - 1];

  var contents = '';
  var removeUrl = '';
  try {
    var raw = sessionStorage.getItem('rcEditBundle:' + handle);
    if (raw) {
      var data = JSON.parse(raw);
      contents = data.contents || '';
      removeUrl = data.removeUrl || '';
      // Keep in sessionStorage until the add succeeds so a page refresh still works.
    }
  } catch (e) { }

  injectEditBanner(contents);
  renameAddToCartButton();
  var rcBundleEditConfig = window.RC_BUNDLE_EDIT_CONFIG;

  prefillRechargeFrequencyFromQuery().then(function () {
    if (rcBundleEditConfig.useNativeRechargeQueryPrefill) {
      if (rcBundleEditConfig.debug) {
        console.log('[RC Edit] Manual bundle prefill disabled. Relying on Recharge native query-param prefill.', {
          variant: params.get('variant'),
          contents: params.get('contents')
        });
      }
    } else {
      prefillRechargeBundleFromQuery();
    }
  });

  // After the Recharge widget successfully adds the new bundle, remove the old one.
  if (removeUrl) watchForBundleAdd(handle, removeUrl);

  // Rename "Add to cart" → "Update cart" using the widget's own ready event.
  // Walking text nodes preserves any icons or spans inside the button.
  function renameAddToCartButton() {
    var config = window.RC_BUNDLE_EDIT_CONFIG || {};
    var observerStarted = false;
    var relabelQueued = false;

    function normalize(value) {
      return String(value || '')
        .replace(/\s+/g, ' ')
        .replace(/\s*:\s*/g, ': ')
        .trim();
    }

    function getCompactText(el) {
      return String(el && el.textContent || '')
        .replace(/\s+/g, '')
        .toLowerCase();
    }

    function isRechargeCartButton(btn) {
      if (!btn || !btn.classList) return false;

      // Target the Recharge primary CTA, not each individual product-card Add button.
      if (!btn.classList.contains('recharge-button-primary')) return false;

      var compactText = getCompactText(btn);

      return compactText.indexOf('addtocart') !== -1;
    }

    function getDirectText(el) {
      return normalize(Array.prototype.map.call(el.childNodes || [], function (node) {
        return node.nodeType === Node.TEXT_NODE ? node.nodeValue : '';
      }).join(''));
    }

    function findLabelPieces(btn) {
      var divs = Array.prototype.slice.call(btn.querySelectorAll('div'));

      for (var i = 0; i < divs.length - 2; i++) {
        var first = getDirectText(divs[i]).toLowerCase();
        var second = getDirectText(divs[i + 1]).toLowerCase();
        var third = getDirectText(divs[i + 2]).toLowerCase().replace(/:$/, '');

        if (first === 'add' && second === 'to' && third === 'cart') {
          return {
            add: divs[i],
            to: divs[i + 1],
            cart: divs[i + 2]
          };
        }
      }

      return null;
    }

    function setDirectText(el, text) {
      // Replace only this element's direct text content.
      // Recharge's label pieces are simple divs, so this is safe for Add / to / cart.
      el.textContent = text;
    }

    function relabel() {
      var changed = 0;

      document.querySelectorAll('button.recharge-button-primary').forEach(function (btn) {
        if (!isRechargeCartButton(btn)) return;

        var pieces = findLabelPieces(btn);

        if (!pieces) {
          if (config.debug) {
            console.warn('[RC Edit] Found Recharge cart button, but could not find Add/to/cart label pieces.', btn);
          }

          return;
        }

        setDirectText(pieces.add, 'Update');
        setDirectText(pieces.to, 'bundle:');
        setDirectText(pieces.cart, '');

        btn.setAttribute('data-rc-edit-label', 'update-cart');
        btn.setAttribute('aria-label', normalize(btn.textContent).replace(/^Update\s*cart:/i, 'Update bundle:'));

        changed += 1;
      });

      if (config.debug && changed) {
        console.log('[RC Edit] Relabeled Recharge cart button(s).', changed);
      }

      return changed;
    }

    function queueRelabel() {
      if (relabelQueued) return;

      relabelQueued = true;

      requestAnimationFrame(function () {
        relabelQueued = false;
        relabel();
      });
    }

    function startObserver() {
      if (observerStarted || !document.body) return;
      observerStarted = true;

      var observer = new MutationObserver(queueRelabel);

      observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true
      });

      setTimeout(function () {
        observer.disconnect();
      }, 30000);
    }

    relabel();

    document.addEventListener('bundling-widget:ready', relabel);
    window.addEventListener('bundling-widget:ready', relabel);

    [100, 250, 500, 1000, 2000, 4000, 8000, 12000, 16000].forEach(function (delay) {
      setTimeout(relabel, delay);
    });

    startObserver();
  }

  function watchForBundleAdd(productHandle, urlToRemove) {
    var done = false;
    var _orig = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var url = (args[0] && args[0].url) || args[0] || '';
      return _orig.apply(this, args).then(function (res) {
        if (!done && typeof url === 'string' && /\/cart\/add(\.js)?/.test(url) && res.ok) {
          done = true;
          try { sessionStorage.removeItem('rcEditBundle:' + productHandle); } catch (e) { }
          var updates = {};
          (urlToRemove.match(/updates\[([^\]]+)\]=(\d+)/g) || []).forEach(function (m) {
            var p = m.match(/updates\[([^\]]+)\]=(\d+)/);
            if (p) updates[p[1]] = parseInt(p[2]);
          });
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates })
          }).catch(function () { });
        }
        return res;
      });
    };
  }

  function injectEditBanner(label) {
    var style = document.createElement('style');
    style.textContent =
      '#rc-edit-mode-banner{' +
      'background:#f0ebe2;border-left:4px solid #a10132;' +
      'padding:12px 20px;margin:0 0 16px;' +
      'font-family:var(--text-font-family,sans-serif);font-size:14px;line-height:1.5;' +
      '}' +
      '.rc-edit-banner__title{' +
      'font-family:"Barlow Condensed",sans-serif;font-weight:600;' +
      'text-transform:uppercase;letter-spacing:0.05em;' +
      'font-size:16px;margin:0 0 4px;color:#a10132;' +
      '}' +
      '.rc-edit-banner__body{margin:2px 0;color:#1a1a1a;}';
    document.head.appendChild(style);

    var el = document.createElement('div');
    el.id = 'rc-edit-mode-banner';
    el.setAttribute('role', 'status');
    el.innerHTML =
      '<p class="rc-edit-banner__title">Editing your bundle</p>' +
      (label
        ? '<p class="rc-edit-banner__body">Previous selections: <strong>' + escHtml(label) + '</strong></p>'
        : '') +
      '<p class="rc-edit-banner__body">Make your changes below and click “Update bundle” when ready.</p>';

    var anchor = document.querySelector('main, #MainContent, .main-content, [id*="main"]');
    if (anchor) anchor.prepend(el);
    else document.body.prepend(el);
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

})();

(function () {
  console.log('[RC Debug] Initial URL', location.href);
  console.log('[RC Debug] Initial params', {
    variant: new URLSearchParams(location.search).get('variant'),
    contents: new URLSearchParams(location.search).get('contents'),
    rc_edit: new URLSearchParams(location.search).get('rc_edit'),
    step: new URLSearchParams(location.search).get('step')
  });

  document.addEventListener('bundling-widget:ready', function (event) {
    console.log('[RC Debug] bundling-widget:ready', event);
    console.log('[RC Debug] event.detail', event.detail);
    console.log('[RC Debug] event.details', event.details);
  });

  window.addEventListener('error', function (event) {
    if ((event.filename || '').includes('recharge') || (event.message || '').includes('placement')) {
      console.error('[RC Debug] window error', {
        message: event.message,
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
        error: event.error
      });
    }
  });

  window.addEventListener('unhandledrejection', function (event) {
    console.error('[RC Debug] unhandled rejection', event.reason);
  });
})();


(function () {
  var readyEventSeen = false;

  function logReady(event) {
    readyEventSeen = true;

    console.log('[RC Debug] bundling-widget:ready fired', {
      event: event,
      detail: event.detail,
      details: event.details,
      type: event.type
    });
  }

  document.addEventListener('bundling-widget:ready', logReady);
  window.addEventListener('bundling-widget:ready', logReady);

  setTimeout(function () {
    console.log('[RC Debug] 5s after load', {
      readyEventSeen: readyEventSeen,
      url: location.href,
      hasRechargeBundleGlobal: !!window.RechargeBundle,
      rechargeBundle: window.RechargeBundle || null
    });
  }, 5000);







})();

function prefillRechargeBundleFromQuery() {
  var config = window.RC_BUNDLE_EDIT_CONFIG || {};

  if (config.useNativeRechargeQueryPrefill) {
    if (config.debug) {
      console.log('[RC Edit] Skipping manual prefill because native Recharge query prefill is enabled.');
    }

    return;
  }

  var params = new URLSearchParams(window.location.search);
  var rawContents = params.get('contents');

  if (!rawContents) {
    console.log('[RC Edit] No contents query param found. Skipping prefill.');
    return;
  }

  var items = rawContents
    .split(',')
    .map(function (part) {
      var pieces = part.split(':');

      return {
        productId: pieces[0],
        variantId: pieces[1],
        quantity: parseInt(pieces[2] || '1', 10)
      };
    })
    .filter(function (item) {
      return item.productId && item.variantId && item.quantity > 0;
    });

  if (!items.length) {
    console.warn('[RC Edit] contents query param could not be parsed.', rawContents);
    return;
  }

  console.table(items);

  waitForRechargeCards(items, async function () {
    await prefillRechargeItemsFast(items);
  });
}

function waitForRechargeCards(items, callback) {
  var attempts = 0;
  var maxAttempts = 40; // 40 * 250ms = 10 seconds

  var timer = setInterval(function () {
    attempts += 1;

    var allFound = items.every(function (item) {
      return !!findRechargeCard(item);
    });

    if (allFound) {
      clearInterval(timer);
      callback();
      return;
    }

    if (attempts >= maxAttempts) {
      clearInterval(timer);

      items.forEach(function (item) {
        if (!findRechargeCard(item)) {
          console.warn('[RC Edit] Could not find Recharge card for item.', item);
        }
      });
    }
  }, 250);
}

function findRechargeCard(item) {
  return document.querySelector(
    '[data-recharge-product-id="' + cssEscape(item.productId) + '"]' +
    '[data-recharge-variant-id="' + cssEscape(item.variantId) + '"]'
  );
}

async function prefillRechargeItemsFast(items) {
  var config = window.RC_BUNDLE_EDIT_CONFIG || {};
  var addStaggerMs = Number.isFinite(config.prefillAddStaggerMs)
    ? config.prefillAddStaggerMs
    : 50;

  var quantityRenderWaitMs = Number.isFinite(config.prefillQuantityRenderWaitMs)
    ? config.prefillQuantityRenderWaitMs
    : 250;

  var selectedItems = [];

  if (config.debug) {
    console.log('[RC Edit] Fast-prefilling bundle items.', items);
  }

  // Phase 1: select all products quickly.
  for (var i = 0; i < items.length; i++) {
    var item = items[i];
    var card = findRechargeCard(item);

    if (!card) {
      console.warn('[RC Edit] Missing card for item.', item);
      continue;
    }

    var addButton = findAddButton(card);

    if (!addButton) {
      console.warn('[RC Edit] Could not find Add button for item.', item, card);
      continue;
    }

    if (config.debug) {
      console.log('[RC Edit] Selecting item.', item);
    }

    pressRechargeControl(addButton);
    selectedItems.push(item);

    // Tiny stagger helps React/Recharge process press events without the old 300ms per item cost.
    if (addStaggerMs > 0) {
      await wait(addStaggerMs);
    }
  }

  // Give Recharge one short render window for all selected items.
  await wait(quantityRenderWaitMs);

  // Phase 2: update quantities in parallel.
  await Promise.all(
    selectedItems.map(function (item) {
      return setRechargeBundleItemQuantity(item);
    })
  );

  if (config.debug) {
    console.log('[RC Edit] Fast prefill complete.');
  }
}

async function prefillRechargeItem(item) {
  var card = findRechargeCard(item);

  if (!card) {
    console.warn('[RC Edit] Missing card for item.', item);
    return;
  }

  console.log('[RC Edit] Prefilling item.', item, card);

  var addButton = findAddButton(card);

  if (!addButton) {
    console.warn('[RC Edit] Could not find Add button for item.', item, card);
    return;
  }

  // First click adds/selects the item.
  addButton.click();

  await wait(300);

  // Then use Recharge's actual quantity control:
  // span[role="button"][data-testid="increment"]
  await setRechargeBundleItemQuantity(item);
}

function findAddButton(card) {
  var buttons = Array.prototype.slice.call(card.querySelectorAll('button'));

  return buttons.find(function (btn) {
    return !btn.disabled && /\badd\b/i.test(btn.textContent || '');
  });
}


function cssEscape(value) {
  if (window.CSS && typeof window.CSS.escape === 'function') {
    return window.CSS.escape(String(value));
  }

  return String(value).replace(/"/g, '\\"');
}

async function setRechargeBundleItemQuantity(item) {
  var desiredQuantity = parseInt(item.quantity, 10);

  if (!desiredQuantity || desiredQuantity <= 1) {
    return true;
  }

  var productId = String(item.productId);
  var variantId = String(item.variantId);

  var itemBox = await waitForRechargeItemBox(productId, variantId, 8000);

  if (!itemBox) {
    console.warn('[RC Edit] Could not find Recharge item box for quantity update.', item);
    return false;
  }

  var input = itemBox.querySelector('input[type="number"]');
  var increment = itemBox.querySelector('[data-testid="increment"][role="button"], [data-testid="increment"]');

  if (!input || !increment) {
    console.warn('[RC Edit] Could not find quantity input or increment control.', {
      item: item,
      itemBox: itemBox,
      input: input,
      increment: increment
    });
    return false;
  }

  var attempts = 0;
  var maxAttempts = desiredQuantity + 5;

  while (getRechargeQuantity(input) < desiredQuantity && attempts < maxAttempts) {
    pressRechargeControl(increment);

    // Recharge is React-rendered, so give state/rendering time to update.
    var config = window.RC_BUNDLE_EDIT_CONFIG || {};
    var quantityStepDelayMs = Number.isFinite(config.prefillQuantityStepDelayMs)
      ? config.prefillQuantityStepDelayMs
      : 80;

    await wait(quantityStepDelayMs);

    input = itemBox.querySelector('input[type="number"]') || input;
    increment = itemBox.querySelector('[data-testid="increment"][role="button"], [data-testid="increment"]') || increment;

    attempts += 1;
  }

  var finalQuantity = getRechargeQuantity(input);

  if (finalQuantity !== desiredQuantity) {
    console.warn('[RC Edit] Could not fully increment item quantity.', {
      item: item,
      desiredQuantity: desiredQuantity,
      finalQuantity: finalQuantity,
      remaining: desiredQuantity - finalQuantity
    });
    return false;
  }

  console.log('[RC Edit] Quantity updated.', {
    item: item,
    quantity: finalQuantity
  });

  return true;
}

function getRechargeQuantity(input) {
  var value = parseInt(input.value || input.getAttribute('value') || '0', 10);
  return Number.isFinite(value) ? value : 0;
}

function pressRechargeControl(el) {
  if (!el) return;

  // React Aria pressables often respond better to pointer/mouse events than click alone.
  try {
    el.dispatchEvent(new PointerEvent('pointerdown', { bubbles: true, pointerType: 'mouse' }));
    el.dispatchEvent(new PointerEvent('pointerup', { bubbles: true, pointerType: 'mouse' }));
  } catch (e) { }

  el.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
  el.dispatchEvent(new MouseEvent('mouseup', { bubbles: true }));
  el.dispatchEvent(new MouseEvent('click', { bubbles: true }));

  // Extra fallback for role="button" pressables.
  el.dispatchEvent(new KeyboardEvent('keydown', { bubbles: true, key: 'Enter', code: 'Enter' }));
  el.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true, key: 'Enter', code: 'Enter' }));
}

async function waitForRechargeItemBox(productId, variantId, timeoutMs) {
  var selector =
    '.recharge-bundle-product-item' +
    '[data-recharge-product-id="' + productId + '"]' +
    '[data-recharge-variant-id="' + variantId + '"]';

  var started = Date.now();

  while (Date.now() - started < timeoutMs) {
    var el = document.querySelector(selector);

    if (el) {
      return el;
    }

    await wait(100);
  }

  return null;
}

function wait(ms) {
  return new Promise(function (resolve) {
    setTimeout(resolve, ms);
  });
}

async function prefillRechargeFrequencyFromQuery() {
  var config = window.RC_BUNDLE_EDIT_CONFIG || {};
  var params = new URLSearchParams(window.location.search);
  var sellingPlan = params.get('rc_selling_plan');

  if (sellingPlan === null || sellingPlan === '') {
    if (config.debug) {
      console.log('[RC Edit] No rc_selling_plan query param found. Skipping frequency prefill.');
    }

    return false;
  }

  sellingPlan = String(sellingPlan);

  var select = await waitForRechargeFrequencySelect(12000);

  if (!select) {
    console.warn('[RC Edit] Could not find Recharge frequency select.');
    return false;
  }

  var option = Array.prototype.slice.call(select.options || []).find(function (opt) {
    return String(opt.value) === sellingPlan;
  });

  if (!option) {
    console.warn('[RC Edit] Could not find Recharge frequency option.', {
      sellingPlan: sellingPlan,
      availableOptions: Array.prototype.slice.call(select.options || []).map(function (opt) {
        return {
          value: opt.value,
          text: normalizeRechargeText(opt.textContent || opt.label)
        };
      })
    });

    return false;
  }

  var selected = await selectRechargeFrequencyOption(select, option);

  if (config.debug) {
    console.log('[RC Edit] Frequency prefill complete.', {
      sellingPlan: sellingPlan,
      label: normalizeRechargeText(option.textContent || option.label),
      selected: selected,
      currentSelectValue: select.value
    });
  }

  return selected;
}

function waitForRechargeFrequencySelect(timeoutMs) {
  var started = Date.now();

  return new Promise(function (resolve) {
    var timer = setInterval(function () {
      var select = findRechargeFrequencySelect();

      if (select) {
        clearInterval(timer);
        resolve(select);
        return;
      }

      if (Date.now() - started >= timeoutMs) {
        clearInterval(timer);
        resolve(null);
      }
    }, 150);
  });
}

function findRechargeFrequencySelect() {
  var selects = Array.prototype.slice.call(
    document.querySelectorAll('[data-testid="hidden-select-container"] select, select')
  );

  return selects.find(function (select) {
    var optionText = Array.prototype.slice.call(select.options || [])
      .map(function (opt) {
        return normalizeRechargeText(opt.textContent || opt.label);
      })
      .join(' ');

    return /one time only/i.test(optionText) &&
      /every\s+\d+\s+weeks/i.test(optionText);
  }) || null;
}

async function selectRechargeFrequencyOption(select, option) {
  var sellingPlan = String(option.value);
  var optionLabel = normalizeRechargeText(option.textContent || option.label);

  // First try the hidden native select.
  // This may work if Recharge has wired change/input listeners to it.
  select.value = sellingPlan;
  select.dispatchEvent(new Event('input', { bubbles: true }));
  select.dispatchEvent(new Event('change', { bubbles: true }));

  await wait(300);

  if (String(select.value) === sellingPlan && visibleRechargeFrequencyMatches(optionLabel)) {
    return true;
  }

  // React Aria fallback: open the visible dropdown and click the matching option.
  var trigger = findRechargeFrequencyTrigger(select);

  if (!trigger) {
    console.warn('[RC Edit] Could not find visible Recharge frequency trigger.');
    return String(select.value) === sellingPlan;
  }

  pressRechargeControl(trigger);

  var optionEl = await waitForRechargeFrequencyOption(optionLabel, 5000);

  if (!optionEl) {
    console.warn('[RC Edit] Could not find visible Recharge frequency option.', {
      sellingPlan: sellingPlan,
      optionLabel: optionLabel
    });

    return String(select.value) === sellingPlan;
  }

  pressRechargeControl(optionEl);

  await wait(500);

  return String(select.value) === sellingPlan || visibleRechargeFrequencyMatches(optionLabel);
}

function findRechargeFrequencyTrigger(select) {
  var card = select.closest('.recharge-card') || document;

  return card.querySelector('[role="button"][aria-label="Frequency"], .recharge-select[role="button"]') ||
    document.querySelector('[role="button"][aria-label="Frequency"], .recharge-select[role="button"]');
}

function waitForRechargeFrequencyOption(optionLabel, timeoutMs) {
  var started = Date.now();
  var wanted = normalizeRechargeComparableText(optionLabel);

  return new Promise(function (resolve) {
    var timer = setInterval(function () {
      var options = Array.prototype.slice.call(
        document.querySelectorAll('[role="option"], [data-key], [data-value]')
      );

      var match = options.find(function (el) {
        if (!isVisibleRechargeElement(el)) return false;

        var text = normalizeRechargeComparableText(el.textContent);

        return text === wanted ||
          text.indexOf(wanted) !== -1 ||
          wanted.indexOf(text) !== -1;
      });

      if (match) {
        clearInterval(timer);
        resolve(match);
        return;
      }

      if (Date.now() - started >= timeoutMs) {
        clearInterval(timer);
        resolve(null);
      }
    }, 100);
  });
}

function visibleRechargeFrequencyMatches(optionLabel) {
  var wanted = normalizeRechargeComparableText(optionLabel);

  var triggers = Array.prototype.slice.call(
    document.querySelectorAll('[role="button"][aria-label="Frequency"], .recharge-select[role="button"]')
  );

  return triggers.some(function (trigger) {
    var text = normalizeRechargeComparableText(trigger.textContent);

    return text === wanted || text.indexOf(wanted) !== -1;
  });
}

function normalizeRechargeText(value) {
  return String(value || '').replace(/\s+/g, ' ').trim();
}

function normalizeRechargeComparableText(value) {
  return normalizeRechargeText(value).toLowerCase();
}

function isVisibleRechargeElement(el) {
  if (!el) return false;

  var rect = el.getBoundingClientRect();
  var styles = window.getComputedStyle(el);

  return rect.width > 0 &&
    rect.height > 0 &&
    styles.display !== 'none' &&
    styles.visibility !== 'hidden';
}